import React, { useEffect, useState } from "react";
import MainContent from "../../layouts/maincontent/MainContent";
import styles from "./support.module.css";
import { useNavigate } from "react-router-dom";
import UseAuth from "../../hooks/UseAuth";

function TermsAndCondition({ setCurrentView }) {
  const { auth } = UseAuth();
  const isAuthenticated = Boolean(
    auth && auth.accessToken && auth.accessToken !== "",
  );
  const navigate = useNavigate();

  const handleBack = () => {
    if (isAuthenticated) {
      navigate("/user-settings");
    } else {
      setCurrentView("register");
      navigate("/register");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainContent>
      <section className={`${styles["support-section"]} py-5`}>
        <div className="container">
          {/* HEADER */}
          <div className={`row ${styles["header-col"]}`}>
            <div
              className="col-12 d-flex align-items-center gap-2"
              style={{ marginTop: "-50px" }}
            >
              <button
                className={`${styles["btn-arrow"]} me-2`}
                onClick={handleBack}
                // title="العودة"
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>

              <h5 className={`${styles["support-paragraph"]} mb-0 `}>
                الشروط و الخصوصية والأحكام
              </h5>
            </div>
          </div>
          <>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <u>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    مقدمة
                  </span>
                </u>
              </strong>
            </p>
            <ul style={{ marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    تصف سياسة الخصوصية هذه سياساتنا وإجراءاتنا المتعلقة بجمع
                    معلوماتك واستخدامها والإفصاح عنها عند استخدامك للخدمة وتخبرك
                    بحقوق الخصوصية الخاصة بك وكيف يحميك القانون وخاصه القانون
                    رقم 121 لسنة 2020 الخاص بحماية البيانات الشخصية ولائحته
                    التنفيذية،
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    نستخدم بياناتك الشخصية لتقديم الخدمة وتحسينها. وباستخدام
                    الخدمة، فإنك توافق على جمع واستخدام المعلومات وفقًا لسياسة
                    الخصوصية هذه
                  </span>
                </strong>
              </li>
            </ul>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <u>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    التفسير والتعريفات
                  </span>
                </u>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#002060",
                      }}
                    >
                      ترجمة
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  الكلمات التي يتم كتابة الحرف الأول بها معاني محددة وفقًا
                  للشروط التالية
                </span>
              </strong>
              <span style={{ fontFamily: '"Arial",sans-serif' }}>.</span>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يجب أن يكون للتعريفات التالية نفس المعنى بغض النظر عما إذا
                  كانت تظهر بصيغة المفرد أو الجمع
                </span>
              </strong>
              <strong>
                <span
                  dir="LTR"
                  style={{ fontFamily: "Arial", color: "#002060" }}
                >
                  .
                </span>
              </strong>
            </p>
            <ul style={{ marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    تعريفات لأغراض سياسة الخصوصية هذه
                  </span>
                </strong>
                <strong>
                  <span dir="LTR">:</span>
                </strong>
              </li>
              <li>
                <span dir="LTR">&nbsp;</span>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    الحساب
                  </span>
                </strong>
                <strong>
                  <span style={{ fontFamily: '"Arial",sans-serif' }}>
                    :{" "}
                    <span style={{ color: "#002060" }}>
                      يعني حسابًا فريدًا تم إنشاؤه لك للوصول إلى خدمتنا أو أجزاء
                      من خدمتنا
                    </span>
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    المصلحة:
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    &nbsp;مصلحة الضرائب العقارية، كما يُشار إليها (لنا أو نحن)
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    التطبيق
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    : يعني الموقع الالكتروني الذي توفره المصلحة للاستخدام أو
                    البرنامج الذي تقوم بتنزيله على الهواتف المحمولة.
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span dir="LTR">&nbsp;</span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    البلد
                  </span>
                </strong>
                <span style={{ fontFamily: '"Arial",sans-serif' }}>
                  :
                  <strong>
                    <span style={{ color: "#002060" }}>&nbsp;يشير إلى مصر</span>
                  </strong>
                  .
                </span>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    الجهاز
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    : يعني الهاتف المحمول أو الحاسب الآلي المستخدم لتصفح
                    التطبيق.
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    البيانات الشخصية
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    : هي أي معلومات تتعلق بفرد محدد أو يمكن التعرف عليه
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    تشير الخدمة إلى التطبيق
                  </span>
                </strong>
                <span dir="LTR">.</span>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    مقدم الخدمة:
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    &nbsp;يعني أي شخص طبيعي أو اعتباري يقوم بمعالجة البيانات
                    نيابة عن المصلحة ويشير إلى شركات أو أفراد تابعين لجهات
                    خارجية توظفهم المصلحة لتسهيل الخدمة، لتقديم الخدمة نيابة عن
                    المصلحة، لأداء الخدمات المتعلقة بالخدمة أو لمساعدة المصلحة
                    في تحليل كيفية استخدام الخدمة
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    .
                  </span>
                </strong>
              </li>
              <li>
                <span dir="LTR">&nbsp;</span>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    تشير بيانات الاستخدام
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    &nbsp;إلى البيانات التي يتم جمعها تلقائيًا، إما الناتجة عن
                    استخدام الخدمة أو من البنية التحتية للخدمة نفسها (على سبيل
                    المثال، مدة زيارة الصفحة)
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    أنت:&nbsp;
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    تعني الفرد الذي يصل إلى الخدمة أو يستخدمها، أو أي كيان
                    قانوني آخر يقوم هذا الفرد بالوصول إلى الخدمة أو استخدامها
                    نيابةً عنه، حسب الاقتضاء
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    يقصد بالأشخاص الطبيعية:
                  </span>
                </strong>
                <span style={{ fontFamily: '"Arial",sans-serif' }}>&nbsp;</span>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    هي الافراد وتنقسم الي نوعين
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    :&nbsp;
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    (أ): كامل الاهلية
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    .&nbsp;
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    (ب): ناقص الاهلية مثل القاصر وغيرة ويقر عنه من يمثله قانوناً
                    (الولي / الوصي / القيم) بحسب الاحوال
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    يقصد بالشخص الاعتباري نوعين
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    :&nbsp;
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    (أ): اشخاص اعتبارية عامة: مثل وحدات الإدارة المحلية والهيئات
                    العامة والأجهزة التي لها موازنات خاصه
                  </span>
                </strong>
                <strong>
                  <span
                    dir="LTR"
                    style={{ fontFamily: "Arial", color: "#002060" }}
                  >
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    (ب): اشخاص اعتبارية خاصة: مثل الشركات والجمعيات والنقابات
                    وغيرها من الكيانات سواء كانت مملوكة للدولة ملكية خاصة او
                    مملوكة للأفراد.
                  </span>
                </strong>
              </li>
            </ul>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <u>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    جمع واستخدام بياناتك الشخصية
                  </span>
                </u>
              </strong>
            </p>
            <ul style={{ marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    أنواع البيانات المجمعة
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    بيانات شخصية
                  </span>
                </strong>
              </li>
            </ul>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  أثناء استخدام خدمتنا، قد نطلب منك تزويدنا بمعلومات تعريف شخصية
                  معينة يمكن استخدامها للاتصال بك أو التعرف عليك. قد تتضمن
                  معلومات التعريف الشخصية، على سبيل المثال لا الحصر
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  :
                </span>
              </strong>
            </p>
            <ol style={{ listStyleType: "circle", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    رقم تحقيق الشخصية للأشخاص الطبيعية (رقم بطاقة الرقم القومي/
                    رقم جواز السفر)، رقم السجل التجاري للأشخاص الاعتبارية.
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    عنوان البريد الإلكتروني
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    رقم الهاتف
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    بيانات الاستخدام
                  </span>
                </strong>
              </li>
            </ol>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      بيانات الاستخدام&nbsp;
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يتم جمع بيانات الاستخدام تلقائيًا عند استخدام الخدمة
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  قد تتضمن بيانات الاستخدام معلومات مثل عنوان بروتوكول الإنترنت
                  الخاص بجهازك{" "}
                </span>
              </strong>
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  (
                </span>
              </strong>
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  مثل عنوان
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  {" "}
                  IP{" "}
                </span>
              </strong>
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  )
                </span>
              </strong>
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  ، ونوع المتصفح ، وإصدار المتصفح ، وصفحات الخدمة التي تزورها ،
                  ووقت وتاريخ زيارتك ، والوقت الذي تقضيه على تلك الصفحات ،
                  ومعرفات الجهاز الفريدة والبيانات التشخيصية الأخرى
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  عندما تصل إلى الخدمة عن طريق الموقع الإلكتروني أو من خلال هاتف
                  محمول ، يجوز لنا جمع معلومات معينة تلقائيًا ، بما في ذلك ، على
                  سبيل المثال لا الحصر:
                </span>
              </strong>
            </p>
            <ol style={{ listStyleType: "circle", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    نوع الجهاز الذي تستخدمه
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    المعرف الفريد للجهاز
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    عنوان
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    &nbsp;IP&nbsp;
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    للجهاز
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    نظام التشغيل لجهازك
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    نوع متصفح الإنترنت على الجهاز الذي تستخدمه
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    معرفات الجهاز الفريدة
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    بيانات التشخيص الأخرى
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    .
                  </span>
                </strong>
              </li>
            </ol>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  قد نقوم أيضًا بجمع المعلومات التي يرسلها متصفحك عندما تزور
                  خدمتنا أو عندما تصل إلى الخدمة عن طريق أو من خلال الجهاز
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      المعلومات التي تم جمعها أثناء استخدام التطبيق
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  أثناء استخدام تطبيقنا، من أجل توفير ميزات تطبيقنا، قد نجمع،
                  بإذن مسبق منك
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  :
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ol
                style={{
                  marginBottom: "0in",
                  listStyleType: "circle",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#002060",
                      }}
                    >
                      معلومات من دفتر هاتف جهازك (قائمة جهات الاتصال)
                    </span>
                  </strong>
                </li>
              </ol>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  نستخدم هذه المعلومات لتوفير ميزات خدمتنا، لتحسين وتخصيص
                  خدمتنا. قد يتم تحميل المعلومات على خوادم المصلحة و / أو خادم
                  مزود الخدمة أو قد يتم تخزينها ببساطة على جهازك
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <span style={{ fontFamily: '"Arial",sans-serif' }}>&nbsp;</span>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <span dir="LTR">&nbsp;</span>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      استخدام بياناتك الشخصية
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#C00000" }}
                >
                  يجوز للمصلحة استخدام البيانات الشخصية للأغراض التالية
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#C00000" }}>
                  :
                </span>
              </strong>
            </p>
            <ol style={{ listStyleType: "circle", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    لتقديم&nbsp;
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    ومراقبة
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    &nbsp;خدماتنا وصيانتها وتحسينها
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    لإدارة حسابك: لإدارة تسجيلك كمستخدم للخدمة. يمكن أن تمنحك
                    البيانات الشخصية التي تقدمها إمكانية الوصول إلى الوظائف
                    المختلفة للخدمة المتاحة لك كمستخدم مسجل.
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    للاتصال بك: للاتصال بك عن طريق البريد الإلكتروني أو
                    المكالمات الهاتفية أو الرسائل النصية القصيرة أو غيرها من
                    أشكال الاتصالات الإلكترونية المماثلة، مثل الإخطارات الفورية
                    لتطبيقات الهاتف المحمول والموقع الالكتروني فيما يتعلق
                    بالتحديثات أو الاتصالات الإعلامية المتعلقة بالوظائف أو
                    الخدمات المتعاقد عليها، بما في ذلك التحديثات الأمنية، عند
                    الضرورة أو المعقول لتنفيذها
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    لإدارة طلباتك: لحضور وإدارة طلباتك إلينا
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    .
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    لأغراض أخرى: قد نستخدم معلوماتك لأغراض أخرى، مثل تحليل
                    البيانات، وتحديد اتجاهات الاستخدام، وتحديد فعالية حملاتنا
                    الترويجية وتقييم وتحسين خدماتنا وتجربتك
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    .
                  </span>
                </strong>
              </li>
            </ol>
            <ul style={{ listStyleType: "disc", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    قد نشارك معلوماتك الشخصية في المواقف التالية
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#C00000" }}>
                    :
                  </span>
                </strong>
                <ol style={{ listStyleType: "circle" }}>
                  <li>
                    <span dir="LTR">&nbsp;</span>
                    <strong>
                      <span
                        style={{
                          fontFamily: '"Arial",sans-serif',
                          color: "#002060",
                        }}
                      >
                        مع مزودي الخدمة: قد نشارك معلوماتك الشخصية مع مزودي
                        الخدمة لمراقبة وتحليل استخدام خدمتنا وللاتصال بك
                      </span>
                    </strong>
                    <strong>
                      <span dir="LTR" style={{ color: "#002060" }}>
                        .
                      </span>
                    </strong>
                  </li>
                  <li>
                    <strong>
                      <span dir="LTR" style={{ color: "#002060" }}>
                        &nbsp;
                      </span>
                    </strong>
                    <strong>
                      <span
                        style={{
                          fontFamily: '"Arial",sans-serif',
                          color: "#002060",
                        }}
                      >
                        مع الشركات المتعاقد معها: قد نشارك معلوماتك مع الشركات
                        المتعاقد معها لتقديم الخدمة ، وفي هذه الحالة سنطلب من
                        تلك الشركات سياسة الخصوصية هذه
                      </span>
                    </strong>
                    <strong>
                      <span dir="LTR" style={{ color: "#002060" }}>
                        .
                      </span>
                    </strong>
                  </li>
                  <li>
                    <strong>
                      <span
                        style={{
                          fontFamily: '"Arial",sans-serif',
                          color: "#002060",
                        }}
                      >
                        بموافقة خاصة منك: يجوز لنا الكشف عن معلوماتك الشخصية لأي
                        غرض آخر
                      </span>
                    </strong>
                  </li>
                </ol>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    الاحتفاظ ببياناتك الشخصية
                  </span>
                </strong>
              </li>
            </ul>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  ستحتفظ المصلحة ببياناتك الشخصية فقط طالما كان ذلك ضروريًا
                  للأغراض المنصوص عليها في سياسة الخصوصية هذه.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  سنحتفظ ببياناتك الشخصية ونستخدمها بالقدر اللازم للامتثال
                  لالتزاماتنا القانونية
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  ستحتفظ المصلحة أيضًا ببيانات الاستخدام لأغراض التحليل الداخلي.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يتم الاحتفاظ ببيانات الاستخدام عمومًا لفترة زمنية أقصر ، إلا
                  في حالة استخدام هذه البيانات لتعزيز الأمان أو لتحسين وظائف
                  خدمتنا ، أو نحن ملزمون قانونًا بالاحتفاظ بهذه البيانات لفترات
                  زمنية أطول
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      نقل بياناتك الشخصية
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  تتم معالجة معلوماتك ، بما في ذلك البيانات الشخصية ، بالمصلحة
                  وفي أي أماكن أخرى حيث توجد الأطراف المشاركة في المعالجة
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  ستتخذ المصلحة جميع الخطوات اللازمة بشكل معقول لضمان التعامل مع
                  بياناتك بشكل آمن ووفقًا لسياسة الخصوصية هذه.
                </span>
              </strong>
            </p>
            <ul style={{ listStyleType: "disc", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    الإفصاح عن بياناتك الشخصية
                  </span>
                </strong>
                <ol style={{ listStyleType: "circle" }}>
                  <li>
                    <strong>
                      <span
                        style={{
                          fontFamily: '"Arial",sans-serif',
                          color: "#002060",
                        }}
                      >
                        تطبيق القانون
                      </span>
                    </strong>
                  </li>
                </ol>
              </li>
            </ul>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  لأسباب قانونية ، قد يُطلب من المصلحة الكشف عن بياناتك الشخصية
                  إذا طُلب منها ذلك بموجب القانون أو استجابة لطلبات صحيحة من قبل
                  السلطات العامة مثل المحاكم المختلفة.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  &nbsp;
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "circle",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      المتطلبات القانونية الأخرى
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  قد تفصح المصلحة عن بياناتك الشخصية عند الضرورة من أجل
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  :
                </span>
              </strong>
            </p>
            <ul style={{ listStyleType: "square", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    حماية حقوق المصلحة
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    منع أو التحقيق في أي مخالفات محتملة تتعلق بالخدمة
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    حماية السلامة الشخصية لمستخدمي الخدمة أو الجمهور
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    الحماية من المسؤولية القانونية
                  </span>
                </strong>
              </li>
            </ul>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      أمن بياناتك الشخصية
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يعد أمان بياناتك الشخصية أمرًا مهمًا بالنسبة لنا ، ولكن تذكر
                  أنه لا توجد طريقة نقل عبر الإنترنت أو طريقة تخزين إلكتروني
                  آمنة بنسبة 100٪.
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      روابط لمواقع أخرى
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  قد تحتوي خدمتنا على روابط لمواقع أخرى لا نقوم بتشغيلها.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  إذا قمت بالنقر فوق ارتباط جهة خارجية، فسيتم توجيهك إلى موقع
                  الطرف الثالث. ننصحك بشدة بمراجعة سياسة الخصوصية لكل موقع تزوره
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  ليس لدينا أي سيطرة ولا نتحمل أي مسؤولية عن المحتوى أو سياسات
                  الخصوصية أو الممارسات الخاصة بأي مواقع أو خدمات خاصة بطرف ثالث
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      التغييرات على سياسة الخصوصية هذه
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  سنخطرك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذا
                  التطبيق
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  سنخبرك عبر البريد الإلكتروني و / أو إشعارًا بارزًا على خدمتنا،
                  قبل أن يصبح التغيير ساريًا وتحديث تاريخ "آخر تحديث" في الجزء
                  العلوي من سياسة الخصوصية هذه
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يُنصح بمراجعة سياسة الخصوصية هذه بشكل دوري لمعرفة أي تغييرات.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  تسري التغييرات التي تطرأ على سياسة الخصوصية هذه عند نشرها على
                  هذا التطبيق
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul
                style={{
                  marginBottom: "0in",
                  listStyleType: "disc",
                  marginLeft: "0",
                }}
              >
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      اتصل بنا
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يمكنك الاتصال
                  بنا
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  :
                </span>
              </strong>
            </p>
            <ol style={{ listStyleType: "circle", marginLeft: "0" }}>
              <li>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    &nbsp;
                  </span>
                </strong>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    من خلال زيارة هذه الصفحة على موقعنا:&nbsp;
                  </span>
                </strong>
                <strong>
                  <span dir="LTR">
                    <a href="http://www.rta.gov.eg">www.rta.gov.eg</a>
                  </span>
                </strong>
                <strong>
                  <span style={{ fontFamily: '"Arial",sans-serif' }}>
                    &nbsp;
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    الاتصال طريق الرقم المختصر: 17848
                  </span>
                </strong>
              </li>
            </ol>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <span style={{ fontFamily: '"Arial",sans-serif' }}>&nbsp;</span>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <span style={{ fontFamily: '"Arial",sans-serif' }}>&nbsp;</span>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <span dir="LTR">&nbsp;</span>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "center",
              }}
            >
              <strong>
                <u>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    الشروط والاحكام
                  </span>
                </u>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يرجى قراءة هذه الشروط والأحكام بعناية.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  إنّ هذه الشروط والأحكام، وأية شروط وأحكام وإشعارات وتنويهات
                  أخرى واردة في مكان آخر على هذا التطبيق تحكم دخولك واستخدامك
                  لهذا التطبيق.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  وعبر الاستمرار في استخدام و/ أو تصفّح هذا التطبيق و/ أو أية
                  خدمات على التطبيق، فإنك تقرّ وتوافق بموجبه على الالتزام بهذه
                  الشروط والأحكام
                </span>
              </strong>
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  تحتفظ المصلحة بحقها بتغيير الشروط والاحكام من وقت لآخر وعليه
                  يتعين عليك الاطلاع على هذه الشروط والأحكام بصفة دورية ولا
                  يتوجب علينا الاتصال بك أو إعلامك بأي تغييرات تم إجراؤها على
                  الشروط والأحكام ويعتبر استمرار استخدامك للتطبيق بمثابة موافقة
                  على الشروط والاحكام المطبقة في وقت استخدامك التطبيق.
                </span>
              </strong>
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  {" "}
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      حقوق الملكيّة الفكريّة
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يحتوي هذا التطبيق الإلكترونيّ على معلومات ومواد محميّة بموجب
                  القانون رقم 82 لسنة 2002 بإصدار حقوق الملكية الفكرية، بما في
                  ذلك، وعلى سبيل المثال لا الحصر:
                </span>
              </strong>
            </p>
            <ul style={{ listStyleType: "disc", marginLeft: "0" }}>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#002060",
                    }}
                  >
                    حقوق قواعد البيانات، من محتوى ومواد مدرجة في هذا التطبيق،
                    كالرسومات، والرسومات التوضيحية، والنصوص، والصور، والبرامج
                    والتنزيلات الرقمية، ومقاطع الصوت والفيديو، أو أي مزيج منها
                    أو من مواد أخرى. ويمثّل كلّ ما ورد ذكره في هذا البند من مواد
                    ومعلومات ومحتوى ملكية حصريّة لمصلحة الضرائب العقارية ومحمياً
                    بموجب حقوق الطبع والنشر وقواعد البيانات المعمول بها
                    والقوانين الأخرى
                  </span>
                </strong>
                <strong>
                  <span dir="LTR" style={{ color: "#002060" }}>
                    &nbsp;.
                  </span>
                </strong>
              </li>
              <li>
                <strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    استخدام خدمات التطبيق
                  </span>
                </strong>
              </li>
            </ul>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يمكن استخدام الخدمات المتاحة على التطبيق فى إطار القوانين
                  والشروط والأحكام واجبة التطبيق علماً بأنه قد لا تتوفر جميع
                  الخدمات الموضحة في هذا التطبيق في جميع الأوقات أو في جميع
                  المناطق.
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  وإن أهليتك للحصول على أية خدمات معينة تخضع للقرار النهائي
                  والموافقة الصادرة من جانب مصلحة الضرائب العقارية
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      الاعفاء من المسؤولية
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  لن تكون مصلحة الضرائب العقارية مسئولة عن أية أضرار مباشرة أو
                  غير مباشرة ناتجة عن استخدامك لهذا التطبيق، بما في ذلك على سبيل
                  المثال لا الحصر، أي مسؤولية عن أي خسارة ناجمة عن الاعتماد على
                  المعلومات المالية وغيرها من المعلومات أو المواد الواردة في
                  التطبيق.
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      قيود على الاستخدام
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  بصفتك مستخدمًا لهذا التطبيق ، فإنك توافق على عدم إساءة استخدام
                  هذا التطبيق الإلكتروني بأي حال من الأحوال؛ ويشمل ذلك ، على
                  سبيل المثال لا الحصر، التشهير أو التهديد أو الإساءة بما ينتهك
                  حقوق أي شخص آخر بموجب القانون؛ أو أي مخالفة أو انتهاك أي ملكية
                  فكرية أو علامة تجارية أو حقوق نشر أو قاعدة بيانات أو قوانين
                  أخرى معمول بها أو أية أغراض غير قانونية؛ إلحاق الضرر أو التدخل
                  في عمليّات أية أجهزة و/ أو برامج شخص آخر عن طريق تحميل فيروسات
                  أو إرسالها أو تنزيلها أو أي ملفات فاسدة بهذا الخصوص؛ نقل أو
                  الإفصاح عن الأسرار التجارية أو أي مواد أو معلومات سرية أخرى؛
                  أو توجيه أو رفع أي برامج آلية أو برمجيات ضارّة أو برامج تتبّع
                  الارتباطات أو أي عملية تلقائية أخرى قد تؤدي إلى إضعاف هذا
                  التطبيق أو الإضرار ببرامجنا أو شبكة الموقع أو بنيته الأساسية.
                  كما توافق كذلك على عدم انتهاك حقوق الملكية الفكرية أو أية حقوق
                  أخرى لأشخاص آخرين
                </span>
              </strong>
              <strong>
                <span
                  dir="LTR"
                  style={{ fontFamily: "Arial", color: "#002060" }}
                >
                  .
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      ضمان التعويض
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  يحق للمصلحة الرجوع على المسئول عن أي ضرر يلحق بها نتيجة إساءة
                  استخدام هذا التطبيق على النحو السابق أو استخدام التطبيق باي
                  صورة لا تتفق مع أحكام القوانين والشروط والأحكام واجبة التطبيق
                </span>
              </strong>
              <strong>
                <span
                  dir="LTR"
                  style={{ fontFamily: "Arial", color: "#002060" }}
                >
                  .
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      الحساب الخاص بك
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  إذا كنت تستخدم هذا التطبيق فأنت مسؤول عن الحفاظ على سرية
                  معلومات الحساب الخاص بك ورقمك السري وعن تقييد الوصول إلى
                  الجهاز الخاص بك، وتوافق على تحمل مسؤولية جميع الأنشطة التي
                  تحدث ضمن الحساب الخاص بك أو رقمك السري. وتحتفظ مصلحة الضرائب
                  العقارية بحق رفض الخدمة وإنهاء الحساب أو تعليقه
                </span>
              </strong>
              <strong>
                <span
                  dir="LTR"
                  style={{ fontFamily: "Arial", color: "#002060" }}
                >
                  .{" "}
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      سرية المعلومات
                    </span>
                  </strong>
                  <strong>
                    <span dir="LTR" style={{ color: "#C00000" }}>
                      :
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  تطبق فى شأن الالتزام بسرية المعلومات والبيانات أحكام القوانين
                  المعمول بها في هذا الشأن وبصفة خاصة قانون العقوبات وقانون
                  حماية البيانات الشخصية وقانون الإجراءات الضريبية الموحد.
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      الاستفادة من التيسيرات الضريبية
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  في حالة السداد للاستفادة من التيسيرات الضريبية ثم الاعتراض
                  البنكي على هذه المدفوعة و استردادها يسقط حقك في الاستفادة من
                  التيسيرات الضريبية ومنها على سبيل المثال لا الحصر سداد اصل
                  الضريبية للتجاوز عن مقابل التأخير والسداد للتصالح من المنازعات
                  الضريبية.
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      السداد تحت حساب الضريبة
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  في حالة السداد تحت حساب الضريبة للاستفادة من الحوافز الضريبية
                  ثم الاعتراض البنكي على هذه المدفوعة و استردادها يسقط حقك في
                  الاستفادة من التيسيرات الضريبية المقررة بالسداد تحت الحساب
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      رد الضريبة
                    </span>
                  </strong>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  لا يجوز رد الضريبة المسددة إلا في الحالات الواردة بنص القانون
                  ويتم تقديم طلب بذلك.
                </span>
              </strong>
            </p>
            <div
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <ul style={{ marginBottom: "0in", marginLeft: "0" }}>
                <li
                  style={{
                    marginTop: "0in",
                    marginRight: "0in",
                    marginBottom: "8.0pt",
                    marginLeft: "0in",
                    lineHeight: "115%",
                    fontSize: 16,
                    fontFamily: '"Calibri",sans-serif',
                  }}
                >
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Arial",sans-serif',
                        color: "#C00000",
                      }}
                    >
                      التظلم من الربط الضريبي
                    </span>
                  </strong>
                  <span
                    style={{
                      fontFamily: '"Arial",sans-serif',
                      color: "#C00000",
                    }}
                  >
                    :&nbsp;
                  </span>
                </li>
              </ul>
            </div>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span
                  style={{ fontFamily: '"Arial",sans-serif', color: "#002060" }}
                >
                  ليحق لك التظلم من الربط الضريبي الكترونياً فور اتاحة الخدمة .
                </span>
              </strong>
            </p>
            <p
              dir="RTL"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "115%",
                fontSize: 16,
                fontFamily: '"Calibri",sans-serif',
                textAlign: "justify",
              }}
            >
              <strong>
                <span dir="LTR" style={{ color: "#002060" }}>
                  &nbsp;
                </span>
              </strong>
            </p>
          </>
        </div>
      </section>
    </MainContent>
  );
}

export default TermsAndCondition;
